module.exports = __webpack_public_path__ + "img/flyer-2.4af3439c.png";